import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
export default {
  components: {},
  props: {
    message: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    renderMessage: function renderMessage() {
      if (this.message.includes('###JUHUI###FAGUIJIEDU###')) {
        return '<div class="analysis-tag">法规解读</div>' + (this.message.split('###TITEL###')[1] || '未知标题');
      } else {
        return this.message;
      }
    }
  }
};